import { ChevronRight } from "lucide-react";
import { cn } from "@/modern/utils";
import type { ManifestTagView } from "../utils/useManifestMarketingTags";
import { TAG_TYPE_COLORS } from "./TagReviewListPanel";

interface TagReviewDetailPanelProps {
  tag: ManifestTagView | null;
  linkedProblemLabel?: string | null;
}

export const TagReviewDetailPanel = ({
  tag,
  linkedProblemLabel,
}: TagReviewDetailPanelProps) => {
  return (
    <div className="flex w-[45%] min-w-0 shrink-0 flex-col h-full min-h-0">
      {tag ? (
        <div className="flex flex-col h-full min-h-0">
          <div className="px-5 py-4 shrink-0 border-b border-border">
            <h3 className="text-sm font-semibold text-foreground">{tag.label}</h3>
            <span
              className={cn(
                "inline-block mt-1 rounded-full px-2 py-0.5 text-[9px] font-semibold uppercase tracking-wide",
                TAG_TYPE_COLORS[tag.type] ?? "bg-muted text-muted-foreground",
              )}
            >
              {tag.type}
            </span>
          </div>

          <div className="flex-1 min-h-0 overflow-y-auto px-5 py-4 space-y-4">
            {tag.description ? (
              <div className="space-y-1.5">
                <span className="text-xs font-medium text-muted-foreground">Description</span>
                <p className="text-sm text-foreground leading-relaxed">{tag.description}</p>
              </div>
            ) : null}

            {tag.tag_group && tag.tag_group !== tag.type ? (
              <div className="space-y-1.5">
                <span className="text-xs font-medium text-muted-foreground">Group</span>
                <p className="text-sm text-foreground capitalize">{tag.tag_group.replace(/_/g, " ")}</p>
              </div>
            ) : null}

            {tag.type === "solution" && linkedProblemLabel ? (
              <div className="space-y-1.5">
                <span className="text-xs font-medium text-muted-foreground">Linked problem</span>
                <p className="text-sm text-foreground">{linkedProblemLabel}</p>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div className="flex flex-1 flex-col items-center justify-center px-6 text-center min-h-[200px]">
          <div className="rounded-full bg-muted p-3 mb-3">
            <ChevronRight size={20} className="text-muted-foreground" />
          </div>
          <p className="text-sm font-medium text-muted-foreground">Select a tag</p>
          <p className="text-xs text-muted-foreground/60 mt-1 max-w-[240px] leading-relaxed">
            Click any tag on the left to view its details.
          </p>
        </div>
      )}
    </div>
  );
};
